module.exports = "/assets/data/67ab456a9f3bafc71ead3644276bed59-HP18.data.json";